import AddEditBankAccountForm from "./Component/AddEditBankAccountForm";
import BottomDrawer from "components/BottomDrawer";

export default function AddEditBankAccount({
  open,
  onClose,
  bankDataForm,
  selectedBankAccount,
  getBankAccountList,
}) {
  const isEdit = selectedBankAccount;

  return (
    <BottomDrawer
      title={isEdit ? "ویرایش اطلاعات حساب بانکی" : "افزودن حساب بانکی"}
      open={open}
      onClose={onClose}
      dir="rtl"
      maxWidth="xs"
    >
      <AddEditBankAccountForm
        getBankAccountList={getBankAccountList}
        onClose={onClose}
        bankDataForm={bankDataForm}
        selectedBankAccount={selectedBankAccount}
      />
    </BottomDrawer>
  );
}
